module.exports = __webpack_public_path__ + "img/franklin-templeton.6b845c8d.png";